import { createSelector } from 'reselect';

import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';

import { coworkingWorkplaceCountSelector } from '../dump/coworkingWorkplaceCountSelector';
import { getCoworkingFixedWorkplaceSelector } from '../dump/getCoworkingFixedWorkplaceSelector';
import { getCoworkingFlexWorkplaceSelector } from '../dump/getCoworkingFlexWorkplaceSelector';

import { selectedCoworkingTypeSelector } from './selectedCoworkingTypeSelector';

export const coworkingWorkplaceCountAsStringSelector = createSelector(
  [
    selectedCoworkingTypeSelector,
    coworkingWorkplaceCountSelector,
    getCoworkingFlexWorkplaceSelector,
    getCoworkingFixedWorkplaceSelector,
  ],
  (selectedCoworkingType, workplaceCount, flexibleWorkspace, fixedWorkspace) => {
    switch (selectedCoworkingType) {
      case SelectedCoworkingType.FixedWorkplace:
        return fixedWorkspace?.count.toString() ?? '';

      case SelectedCoworkingType.FlexibleWorkplace:
        return flexibleWorkspace?.count.toString() ?? '';

      case SelectedCoworkingType.SeparateOffice:
      case SelectedCoworkingType.None:
      default:
        return workplaceCount?.toString() ?? '';
    }
  },
);
